var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8004 2.8801H12.2004C12.5717 2.8801 12.9278 3.01495 13.1903 3.255C13.4529 3.49505 13.6004 3.82062 13.6004 4.1601V13.1201C13.6004 13.4596 13.4529 13.7851 13.1903 14.0252C12.9278 14.2652 12.5717 14.4001 12.2004 14.4001H3.80039C3.42909 14.4001 3.07299 14.2652 2.81044 14.0252C2.54789 13.7851 2.40039 13.4596 2.40039 13.1201V4.1601C2.40039 3.82062 2.54789 3.49505 2.81044 3.255C3.07299 3.01495 3.42909 2.8801 3.80039 2.8801H5.20039M8.00039 7.3601H10.8004M8.00039 10.5601H10.8004M5.20039 7.3601H5.20739M5.20039 10.5601H5.20739M5.90039 1.6001H10.1004C10.487 1.6001 10.8004 1.88664 10.8004 2.2401V3.5201C10.8004 3.87356 10.487 4.1601 10.1004 4.1601H5.90039C5.51379 4.1601 5.20039 3.87356 5.20039 3.5201V2.2401C5.20039 1.88664 5.51379 1.6001 5.90039 1.6001Z",
    stroke: "#33363F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notesIcon.e4df504022de8b294b249ab502190160.svg";
export { ForwardRef as ReactComponent };